import { FileText } from "lucide-react";

// Flexible specification table. specs: [{ label, value }]. Empty -> clean state.
export default function SpecTable({ specs = [] }) {
  if (!specs || specs.length === 0) {
    return (
      <div data-testid="specs-empty" className="border border-dashed border-border rounded-lg p-10 text-center">
        <div className="w-12 h-12 rounded-full bg-[#f6f8f9] flex items-center justify-center mx-auto mb-4">
          <FileText className="w-5 h-5 text-greyish" strokeWidth={1.75} />
        </div>
        <p className="font-semibold text-ink">Specifications available on request</p>
        <p className="mt-1 text-sm text-greyish max-w-sm mx-auto">
          Detailed technical specifications for this product will be shared by our team. Contact us for full documentation.
        </p>
      </div>
    );
  }
  return (
    <div data-testid="specs-table" className="overflow-hidden border border-border rounded-lg">
      <table className="w-full text-sm">
        <tbody>
          {specs.map((s, i) => (
            <tr key={i} className={i % 2 ? "bg-[#f9fafb]" : "bg-white"}>
              <th className="text-left font-semibold text-ink px-5 py-3.5 w-1/3 align-top">{s.label}</th>
              <td className="text-greyish px-5 py-3.5">{s.value}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
